// Global Cart Kit design tokens — single source of truth for the design system.
// Consumed by the MUI theme (src/theme/getLightTheme.ts) and re-exported as
// `getThemeTokens` for components that read raw color values.
// Palette: "Direction A — warm editorial" (cream / ink / terracotta / deep green / mustard).

export const colors = {
  primary: '#C4562B',
  primaryDark: '#A34420',
  // Brand mark color — matches favicon.svg / logo.svg / manifest.json.
  logoAccent: '#C4562B',
  background: '#FBF7F0',
  paper: '#FFFFFF',
  surface: '#F3EADA',
  ink: '#241E16',
  textPrimary: '#241E16',
  textSecondary: '#6E5F4B',
  textMuted: '#A08F75',
  border: '#EADFCC',
  success: '#2E7D5B',
  warning: '#B97F10',
  error: '#BC3A2B',
  info: '#1F6E5C',
  accent: '#1F6E5C',
  mustard: '#E5A63B',
  violet: '#7D5A6A',
  orange: '#D97E2E',
} as const;

export const radii = {
  card: 16,
  button: 12,
  input: 12,
  badge: 999,
} as const;

// Only these step values are allowed across the UI.
export const spacing = [4, 8, 12, 16, 24, 32, 48, 64] as const;

export const shadows = {
  resting: '0 1px 2px rgba(60,42,24,0.05)',
  hover: '0 4px 14px rgba(60,42,24,0.10)',
} as const;

export const typography = {
  fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  fontFamilyDisplay: '"Fraunces Variable", "Fraunces", "Georgia", "Times New Roman", serif',
  weights: {
    regular: 400,
    medium: 500,
    bold: 700,
  },
} as const;

export const tokens = {
  ...colors,
  radii,
  spacing,
  shadows,
  typography,
} as const;

export type Tokens = typeof tokens;
